export {
  ATTACK_VECTOR,
  ATTACK_COMPLEXITY,
  PRIVILEGES_REQUIRED,
  USER_INTERACTION,
  SCOPE,
  IMPACT_METRICS,
  CVSS4_ATTACK_VECTOR,
  CVSS4_ATTACK_COMPLEXITY,
  CVSS4_ATTACK_REQUIREMENTS,
  CVSS4_PRIVILEGES_REQUIRED,
  CVSS4_USER_INTERACTION,
  CVSS4_IMPACT_METRICS,
} from '@terra/shared-cvss';

export const getCvssExplanations = (t: (key: string) => string) =>
  ({
    attackVector: {
      title: t('designSystem.cvss.attackVector.title'),
      description: t('designSystem.cvss.attackVector.description'),
      options: {
        N: t('designSystem.cvss.attackVector.options.N'),
        A: t('designSystem.cvss.attackVector.options.A'),
        L: t('designSystem.cvss.attackVector.options.L'),
        P: t('designSystem.cvss.attackVector.options.P'),
      },
    },
    attackComplexity: {
      title: t('designSystem.cvss.attackComplexity.title'),
      description: t('designSystem.cvss.attackComplexity.description'),
      options: {
        L: t('designSystem.cvss.attackComplexity.options.L'),
        H: t('designSystem.cvss.attackComplexity.options.H'),
      },
    },
    attackRequirements: {
      title: t('designSystem.cvss.attackRequirements.title'),
      description: t('designSystem.cvss.attackRequirements.description'),
      options: {
        N: t('designSystem.cvss.attackRequirements.options.N'),
        P: t('designSystem.cvss.attackRequirements.options.P'),
      },
    },
    privilegesRequired: {
      title: t('designSystem.cvss.privilegesRequired.title'),
      description: t('designSystem.cvss.privilegesRequired.description'),
      options: {
        N: t('designSystem.cvss.privilegesRequired.options.N'),
        L: t('designSystem.cvss.privilegesRequired.options.L'),
        H: t('designSystem.cvss.privilegesRequired.options.H'),
      },
    },
    userInteraction: {
      title: t('designSystem.cvss.userInteraction.title'),
      description: t('designSystem.cvss.userInteraction.description'),
      options: {
        N: t('designSystem.cvss.userInteraction.options.N'),
        R: t('designSystem.cvss.userInteraction.options.R'),
      },
    },
    userInteraction40: {
      title: t('designSystem.cvss.userInteraction40.title'),
      description: t('designSystem.cvss.userInteraction40.description'),
      options: {
        N: t('designSystem.cvss.userInteraction40.options.N'),
        P: t('designSystem.cvss.userInteraction40.options.P'),
        A: t('designSystem.cvss.userInteraction40.options.A'),
      },
    },
    scope: {
      title: t('designSystem.cvss.scope.title'),
      description: t('designSystem.cvss.scope.description'),
      options: {
        U: t('designSystem.cvss.scope.options.U'),
        C: t('designSystem.cvss.scope.options.C'),
      },
    },
    confidentiality: {
      title: t('designSystem.cvss.confidentiality.title'),
      description: t('designSystem.cvss.confidentiality.description'),
      options: {
        N: t('designSystem.cvss.confidentiality.options.N'),
        L: t('designSystem.cvss.confidentiality.options.L'),
        H: t('designSystem.cvss.confidentiality.options.H'),
      },
    },
    integrity: {
      title: t('designSystem.cvss.integrity.title'),
      description: t('designSystem.cvss.integrity.description'),
      options: {
        N: t('designSystem.cvss.integrity.options.N'),
        L: t('designSystem.cvss.integrity.options.L'),
        H: t('designSystem.cvss.integrity.options.H'),
      },
    },
    availability: {
      title: t('designSystem.cvss.availability.title'),
      description: t('designSystem.cvss.availability.description'),
      options: {
        N: t('designSystem.cvss.availability.options.N'),
        L: t('designSystem.cvss.availability.options.L'),
        H: t('designSystem.cvss.availability.options.H'),
      },
    },
    subsequentIntegrity: {
      title: t('designSystem.cvss.subsequentIntegrity.title'),
      description: t('designSystem.cvss.subsequentIntegrity.description'),
      options: {
        N: t('designSystem.cvss.subsequentIntegrity.options.N'),
        L: t('designSystem.cvss.subsequentIntegrity.options.L'),
        H: t('designSystem.cvss.subsequentIntegrity.options.H'),
      },
    },
    subsequentAvailability: {
      title: t('designSystem.cvss.subsequentAvailability.title'),
      description: t('designSystem.cvss.subsequentAvailability.description'),
      options: {
        N: t('designSystem.cvss.subsequentAvailability.options.N'),
        L: t('designSystem.cvss.subsequentAvailability.options.L'),
        H: t('designSystem.cvss.subsequentAvailability.options.H'),
      },
    },
  }) as const;

export type CVSSMetricKey = keyof ReturnType<typeof getCvssExplanations>;
